'use client';

import useSWR from 'swr';
import { categoriesApi } from '@/lib/api';
import type { ParentCategory } from '@/types';
import { LONG_LIVED_SWR_OPTIONS, useAuthedFetcher } from './swrConfig';

export function useCategories(enabled = true) {
  const authedFetch = useAuthedFetcher();

  return useSWR<ParentCategory[]>(
    enabled ? ['categories'] : null,
    () => authedFetch((token) => categoriesApi.getAll(token)),
    LONG_LIVED_SWR_OPTIONS,
  );
}
